module.exports = __webpack_public_path__ + "img/20201201_153706.692dbd1e.jpg";